// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".wsp__products[data-v-8f7e1b82]{display:grid;grid-template-rows:1fr 300px}.wsp__products .wsp__list[data-v-8f7e1b82]{overflow:auto;background-color:#fff}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
